import gql from "graphql-tag";

export const ADD_ACTIVITY = gql`
  mutation insert_activity($action: String!, $description: String!) {
    insert_activity(objects: [{ action: $action, description: $description }]) {
      affected_rows
    }
  }
`;
